gsap.set(".co-about-1-right-frame", { opacity: 0 });
gsap.to(".co-about-1-right-frame", {
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set(".co-about-1-left", { opacity: 0 });
gsap.to(".co-about-1-left", {
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
// scrub
gsap.set('.co-about-1-left-frame img', { scale: 0.87 });
gsap.to('.co-about-1-left-frame img', {
  scrollTrigger: {
    start: 'top top',
    end: 'bottom top',
    trigger: 'body',
    endTrigger: '.co-about-1',
    scrub: true
  },
  scale: 1
});
// 2
gsap.set('.co-about-2-header', { opacity: 0 });
gsap.to('.co-about-2-header', {
  scrollTrigger: {
    trigger: '.co-about-2',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set('.co-about-2-cell', { opacity: 0 });
gsap.to('.co-about-2-cell', {
  scrollTrigger: {
    trigger: '.co-about-2-cell',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
// 3
gsap.set('.co-about-3-header-frame', { opacity: 0 });
gsap.to('.co-about-3-header-frame', {
  scrollTrigger: {
    trigger: '.co-about-3',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set('.co-about-3-image-frame img', { top: "0%" });
gsap.to('.co-about-3-image-frame img', {
  scrollTrigger: {
    start: 'top bottom',
    end: 'bottom top',
    trigger: '.co-about-3',
    scrub: true
  },
  top: "-10%"
});
// 4
gsap.set('.co-about-4-header', { opacity: 0 });
gsap.to('.co-about-4-header', {
  scrollTrigger: {
    trigger: '.co-about-4',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set('.co-about-4-cell', { opacity: 0 });
gsap.to('.co-about-4-cell', {
  scrollTrigger: {
    trigger: '.co-about-4-cell',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
